export const navItemsMobile = [
	{
		title: "User",
		text: "User",
		icon: "fa-user",
		id: "user",
		selected: true,
		route: "/user/",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true,
	},
	{
        title: "Dashboard",
        text: "Dashboard",
		icon: "fa-gauge",
        id: "dashboards",
        route: "/dashboards/",
		orgAdminAllowed: true,        
        workspaceAdminAllowed: true
	},
	{
		title: "Profile",
		text: "Profile",
		icon: "fa-street-view",
		id: "profile",
		route: "/profile/",
		workspaceAdminAllowed: true,
		orgAdminAllowed: true
	},
	{
		title: "Messages",
		text: "Messages",
		icon: "fa-mail",
		id: "messages",
		route: "/messages/",
		workspaceAdminAllowed: true,
		orgAdminAllowed: true
	},
	{ 
		title: "Control Panel",
		text: "Control Panel",
		icon: "fa-sliders",
		id: "control",
		expanded: false,
		orgAdminAllowed: true,
		workspaceAdminAllowed: false,
		requiresConstituo: true
	},
	{
		title: "Monitor",
		text: "Monitor",
		icon: "fa-calendar",
		id: "monitor",
		route: "/monitor/",
		parentId: "control",
		orgAdminAllowed: true,
		workspaceAdminAllowed: false,
		requiresConstituo: true
	},
	{
		title: "Thread Pools",
		text: "Thread Pools",
		icon: "fa-tasks",
		id: "threadpools",
		route: "/threadpools/",
		parentId: "control",
		orgAdminAllowed: true,
		workspaceAdminAllowed: false,
		requiresConstituo: true
	},
	{
		title: "Routines",
		text: "Routines",
		icon: "fa-calendar",
		id: "routines",
		route: "/routines/",
		parentId: "control",
		orgAdminAllowed: true,
		workspaceAdminAllowed: false,
		requiresConstituo: true
	},
	{
		title: "Help",
		text: "Help",
		icon: "fa-help",
		id: "help",
		isMenu: true,
		workspaceAdminAllowed: true,
		orgAdminAllowed: true
	},
	{
		title: "About",
		text: "About",
		icon: "fa-info-circled",
		id: "about",
		route: "/about/",
		workspaceAdminAllowed: true,
		orgAdminAllowed: true
	},	
	{
		title: "Log Off",
		text: "Log Off",
		icon: "fa-logout",
		id: "logoff",
		isMenu: true,
		workspaceAdminAllowed: true,
		orgAdminAllowed: true
	},		
];
